import { ref, nextTick, onMounted } from 'vue';
import * as bootstrap from 'bootstrap';

export function useToast() {
  const toastMessage = ref('');
  const toastTitle = ref('');
  const toastError = ref(false);
  const toastRef = ref(null);
  const toastInstance = ref(null);

  function showToast(message, title = 'Info', error = false) {
    toastMessage.value = message;
    toastTitle.value = title;
    toastError.value = error;

    nextTick(() => {
      toastInstance.value?.show();
    });
  }

  function showSuccessToast(message, title = 'Successo') {
    showToast(message, title, false);
  }

  function showErrorToast(message, title = 'Errore') {
    showToast(message, title, true);
  }

  onMounted(() => {
    const el = document.getElementById('saveToast');
    if (el) {
      toastInstance.value = new bootstrap.Toast(el, { autohide: true, delay: 5000 });
    }
  });

  return { toastMessage, toastTitle, toastError, toastRef, showSuccessToast, showErrorToast };
}
